(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('$templateCache', templateCacheDecorator);

    var rVersion = /(&|\?)v=\d+$/i;

    templateCacheDecorator.$inject = ['$delegate'];
    function templateCacheDecorator($delegate) {
        var _get = $delegate.get;
        $delegate.get = get;
        return $delegate;

        function get(key) {
            return _get.call(this, key) || _get.call(this, key.replace(rVersion, ''));
        }
    }
})();
